import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import Modal from '../../../common/modal'

const LRStatusModel = ({ setOpenLrModal, LRTrackStatusData = [] }) => {
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const getStatusLabel = (type) => {
        switch (type?.toUpperCase()) {
            case 'B': return 'Booked'
            case 'T': return 'Branch Transfer'
            case 'G': return 'Branch Transfer Received'
            case 'D': return 'Destination Dispatch'
            case 'R': return 'Destination Received'
            case 'O': return 'Out For Delivery'
            case 'F': return 'Delivered'
            case 'C': return 'Cancelled'
            default: return ''
        }
    }
    const uniqueData = React.useMemo(() => {
        const seen = new Set()
        return LRTrackStatusData.filter(item => {
            if (!item?.Type) return false
            const key = item.Type.toUpperCase()
            if (seen.has(key)) return false
            seen.add(key)
            return true
        })
    }, [LRTrackStatusData])

    const finalStatus = getStatusLabel(LRTrackStatusData[LRTrackStatusData.length - 1]?.Type)

    const renderField = (label, value) => {
        if (!value) return null
        return (
            <Typography variant="body2" style={{ fontWeight: 600, fontSize: '12px' }}>
                {label}: {value}
            </Typography>
        )
    }
    const renderSection = (data, index) => {
        const type = data.Type?.toUpperCase()
        const renderHeader = () => (
            <>
                {index === 0 && (
                    <Paper sx={{ border: '1px solid #0086ff', p: 1.2, mb: 1, }}>
                        <Typography variant="subtitle1" sx={{ color: '#0086ff', fontWeight: 700, fontSize: '14px' }}>
                            Status: {finalStatus}
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            WayBill: {data.LRNO}
                        </Typography>
                    </Paper>
                )}
            </>
        )

        switch (type) {
            case 'B':
                return (
                    <>
                        {renderHeader()}
                        <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                                Booking Details:
                            </Typography>
                            {renderField('Booking Date & Time', data.BookingDatetime)}
                            {renderField('Source', data.SourceCity)}
                            {renderField('Destination', data.DestinationCity)}
                        </Paper>
                    </>
                )

            case 'T':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Branch Transfer Details:
                        </Typography>
                        {renderField('Transfer Date & Time', data.BranchTransferDateTime)}
                        {renderField('Transfer To', data.TransferredToBranch)}
                        {renderField('Vehicle Loaded', data.BranchTransferVehicle)}
                        {renderField('Driver & Co-driver', data.BranchTransferDriverName)}
                    </Paper>
                )

            case 'G':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Branch Transfer Receive Details:
                        </Typography>
                        {renderField('Transfer Receive Date & Time', data.BranchTransferReceiveDateTime)}
                        {renderField('Received At', data.ReceivedAtBranch)}
                        {renderField('Vehicle Loaded', data.BranchTransferReceiveVehicle)}
                        {renderField('Driver & Co-driver', data.BranchTransferReceiveDriverName)}
                    </Paper>
                )

            case 'D':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Dispatch Details:
                        </Typography>
                        {renderField('Dispatch Date & Time', data.DispatchDateTime)}
                        {renderField('Dispatch To', data.DispatchedToBranch)}
                        {renderField('Vehicle Loaded', data.DispatchedVehicle)}
                        {renderField('Driver & Co-driver', data.DispatchedDriverName)}
                    </Paper>
                )

            case 'R':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Receive Details:
                        </Typography>
                        {renderField('Receive Date & Time', data.ReceivedDateTime)}
                        {renderField('Received At', data.ReceivedToBranch)}
                        {renderField('Vehicle Loaded', data.ReceivedVehicle)}
                        {renderField('Driver & Co-driver', data.ReceivedDriverName)}
                    </Paper>
                )

            case 'O':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Out For Delivery Details:
                        </Typography>
                        {renderField('Assigned Date & Time', data.AssignedDateTime)}
                        {renderField('Assigned To', data.AssignedTo)}
                        {renderField('Vehicle Loaded', data.VehicleLoaded)}
                        {renderField('Assigned By', data.AssignedBy)}
                    </Paper>
                )

            case 'F':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Delivery Details:
                        </Typography>
                        {renderField('Delivery Date & Time', data.DeliveredDateTime)}
                        {renderField('Delivered To', data.DeliveredTo)}
                        {renderField('Vehicle Loaded', data.DeliveryVehicleLoaded)}
                        {renderField('Delivered By', data.DeliveredBy)}
                    </Paper>
                )
            case 'C':
                return (
                    <Paper key={index} sx={{ border: '1px solid #0086ff', p: 1.5, mb: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                            Cancel Details:
                        </Typography>
                        {renderField('Cancel Date & Time', data.RefundDatetime)}
                        {renderField('Cancel By', data.RefundBy)}
                    </Paper>
                )

            default:
                return null
        }
    }


    return (
        <Modal
            headTxt="LR Status"
            width="20%"
            updateModal={() => setOpenLrModal(false)}
            modalClass="booking-popup"
            modalStyle={modalStyle}
        >
            <Box sx={{ p: 2 }}>
                {uniqueData.length > 0 ? (
                    uniqueData.map((item, i) => renderSection(item, i))
                ) : (
                    <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center' }}>
                        No tracking data available
                    </Typography>
                )}
            </Box>
        </Modal>
    )
}

export default LRStatusModel
